import { getStopApi } from '../../../../../../services/StopApi/StopApi';

export const getSubsidiariesList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        orgKey: item.orgKey,
        orgId: item.orgId,
        address: item.address,
        city: item.city,
        county: item.county,
        countyName: item.countyName,
        phone: item.phone,
      })),
    };
  }).catch((e) => alert(e));
};
